export const endpoints = {
  pricing: 'v1/pricing',
  contact: 'v1/contact',
};
